module.exports = __webpack_public_path__ + "img/index02.d4966b22.png";